import { Component, signal, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Button } from 'primeng/button';
import { Divider } from 'primeng/divider';
import { FloatLabel } from 'primeng/floatlabel';
import { InputGroup } from 'primeng/inputgroup';
import { InputGroupAddon } from 'primeng/inputgroupaddon';
import { InputText } from 'primeng/inputtext';
import { Popover } from 'primeng/popover';
import { TabsModule } from 'primeng/tabs';
import { TooltipModule } from 'primeng/tooltip';
import { MatIcon } from '@angular/material/icon';
import { Textarea } from 'primeng/textarea';
import {Clipboard} from '@angular/cdk/clipboard';
import {
    DataRecordFormView,
    FormField,
} from '../../../secure/apps/lmdm/model/MDMDataModel';

@Component({
    selector: 'app-tabformview',
    imports: [
        TabsModule,
        TooltipModule,
        FormsModule,
    ],
    templateUrl: './tabformview.component.html',
    styleUrl: './tabformview.component.scss',
    standalone: true,
})
export class TabformviewComponent {
    constructor(private clipboard:Clipboard) {
    }
    selectedDataElement = signal<FormField | null>(null);
    @ViewChild('op') op!: Popover;
    @ViewChild('entityTypePopover') entityTypePopover!: Popover;
    dataRecordView: DataRecordFormView = {
        subjectUri:
            'http://data.operations.cts.cis.mymac.net/organization#yueargax09k57n70etegmc',
        title: 'UBS Financial Services Inc-00000000000000001036',
        resolvedRecordTypeTitle: 'Confirmed/Golden',
        resolvedRecordTypeTooltip:
            'http://spec.ontollogix.net/sdf/sdf-kg-entity-resolution-ontology#Golden',
        entityType: 'DuallyRegisteredFirm',
        entityTypeUri:
            'http://spec.operations.cts.cis.mymac.net/businessdataentity#DuallyRegisteredFirm',
        entityTypeLabel: 'Dually Registered Firm',
        entityTypeDefinition:
            'A dually registered firm refers to a financial institution that is registered as both a broker-dealer and an investment adviser. This means the firm can charge fees for financial planning or investment advice while also earning commissions from selling financial products.',
        tabsList: [],
        survivedProperties: null,
        clusterHeaderColumns: [],
        clusterKeyValueList: null

        //     {
        //         value: 0,
        //         tabName: 'Client Profile',
        //         tabLabel: 'Profile',
        //     },
        //     {
        //         value: 1,
        //         tabName: 'Addresses',
        //         tabLabel: 'All Known addresses for this customer/client',
        //     },
        //     {
        //         value: 2,
        //         tabName: 'Master Records',
        //         tabLabel: 'Master Records',
        //     },
        //     {
        //         value: 3,
        //         tabName: 'Source Data Lineage',
        //         tabLabel: 'Data Lineage  for this Golden Record',
        //     },
        //     {
        //         value: 4,
        //         tabName: 'Change Control',
        //         tabLabel: 'Change Control',
        //     },
        //     {
        //         value: 5,
        //         tabName: 'Graph View',
        //         tabLabel: 'Linked Data Graph View',
        //     },
        // ],
        // tabPanels: [
        //     {
        //         value: 0,
        //         label: 'Test1',
        //         definition: 'Profile Information',
        //         viewport: {
        //             gridcols: 2,
        //             viewGroups: [
        //                 {
        //                     id: 0,
        //                     items: [
        //                         {
        //                             id: 1,
        //                             propertyUri:
        //                                 'http://spec.ontollogix.net/sdf/lo-data-definitions-ontology#uniqueBusinessEntityIdentifier',
        //                             definition:
        //                                 'Unique Business Identifier of the resource',
        //                             label: 'uniqueBusinessEntityIdentifier',
        //                             value: '04N6BH2GW8URDY0AK302',
        //                             colspan: 1,
        //                             propertyName:
        //                                 'uniqueBusinessEntityIdentifier',
        //                             minOccurs: 1,
        //                             maxOccurs: 1,
        //                             nodeKind:
        //                                 'http://www.w3.org/ns/shacl#Literal',
        //                             dataType: 'xsd:string',
        //                         },
        //                         {
        //                             id: 2,
        //                             propertyUri:
        //                                 'http://spec.ontollogix.net/sdf/lo-data-definitions-ontology#uniqueIdentifier',
        //                             definition:
        //                                 'Unique System Identifier of the resource',
        //                             label: 'Unique System Identifier',
        //                             value: '53kfc0ad9d5lxyciarhyyl',
        //                             colspan: 1,
        //                             propertyName: 'uniqueIdentifier',
        //                             minOccurs: 1,
        //                             maxOccurs: 1,
        //                             nodeKind:
        //                                 'http://www.w3.org/ns/shacl#Literal',
        //                         },
        //                     ],
        //                 },
        //                 {
        //                     id: 1,
        //                     items: [
        //                         {
        //                             id: 1,
        //                             propertyUri: 'rdfs:label',
        //                             definition: 'Data Label',
        //                             label: 'Data Label',
        //                             value: 'UBS Financial Services Inc-00000000000000001036',
        //                             colspan: 2,
        //                             propertyName: 'defaultLabel',
        //                             minOccurs: 1,
        //                             maxOccurs: 1,
        //                             nodeKind:
        //                                 'http://www.w3.org/ns/shacl#Literal',
        //                         },
        //                     ],
        //                 },
        //                 {
        //                     id: 2,
        //                     items: [
        //                         {
        //                             id: 1,
        //                             propertyUri:
        //                                 'http://spec.ontollogix.net/sdf/lo-data-definitions-ontology#involvedPartyName',
        //                             definition:
        //                                 'Name of the Involved Party Such as DBA',
        //                             label: 'InvolvedPartyName',
        //                             value: 'UBS Financial Services Inc',
        //                             colspan: 2,
        //                             propertyName: 'involvedPartyName',
        //                             minOccurs: 1,
        //                             maxOccurs: 1,
        //                             nodeKind:
        //                                 'http://www.w3.org/ns/shacl#Literal',
        //                         },
        //                     ],
        //                 },
        //                 {
        //                     id: 201,
        //                     items: [
        //                         {
        //                             id: 1,
        //                             propertyUri:
        //                                 'http://spec.operations.cts.cis.mymac.net#InvestorType',
        //                             definition: 'Type Of Investor',
        //                             label: 'investorType',
        //                             value: 'UBS Financial Services Inc',
        //                             colspan: 2,
        //                             propertyName: 'investorType',
        //                             minOccurs: 1,
        //                             maxOccurs: 1,
        //                             nodeKind: 'http://www.w3.org/ns/shacl#IRI',
        //                         },
        //                     ],
        //                 },
        //                 {
        //                     id: 300,
        //                     items: [
        //                         {
        //                             id: 1,
        //                             propertyUri:
        //                                 'http://spec.operations.cts.cis.mymac.net/businessdataelement#countryOfDoimicile',
        //                             definition:
        //                                 'It is typically the country where a business is incorporated or organized.',
        //                             label: 'Country Of Domicile',
        //                             value: 'USA',
        //                             colspan: 1,
        //                             propertyName: 'countryOfDoimicile',
        //                             minOccurs: 0,
        //                             maxOccurs: 1,
        //                             nodeKind:
        //                                 'http://www.w3.org/ns/shacl#Literal',
        //                         },
        //                         {
        //                             id: 2,
        //                             propertyUri:
        //                                 'http://spec.operations.cts.cis.mymac.net/businessdataelement#countryOfRegistration',
        //                             definition:
        //                                 'The country of registration is the sovereign jurisdiction where a legal entity, ship, or aircraft is officially registered, incorporated, or documented. It dictates the governing laws, regulations, tax obligations, and nationality (flag state) of the asset or company. ',
        //                             label: 'Country Of Registration',
        //                             value: 'USA',
        //                             colspan: 1,
        //                             propertyName: 'countryOfDoimicile',
        //                             minOccurs: 0,
        //                             maxOccurs: 1,
        //                             nodeKind:
        //                                 'http://www.w3.org/ns/shacl#Literal',
        //                         },
        //                         {
        //                             id: 400,
        //                             propertyUri:
        //                                 'http://spec.operations.cts.cis.mymac.net/businessdataelement#leiId',
        //                             definition:
        //                                 'LEI is a 20-character code that uniquely identifies legal entities in financial transactions and other official interactions',
        //                             label: 'legal Entity Identifier',
        //                             value: 'ETYRV6ORNFJB5NONI676',
        //                             colspan: 1,
        //                             propertyName: 'leiId',
        //                             minOccurs: 0,
        //                             maxOccurs: 1,
        //                             nodeKind:
        //                                 'http://www.w3.org/ns/shacl#Literal',
        //                         },
        //                         {
        //                             id: 500,
        //                             propertyUri: 'http://p4',
        //                             definition:
        //                                 'Standing for Central Registration Depository (CRD) number,it’s a unique identifier allocated to each broker and brokerage firm within the United States and managed by FINRA.',
        //                             label: 'CRD Number',
        //                             value: '4567893',
        //                             colspan: 1,
        //                             propertyName: 'crdNumber',
        //                             minOccurs: 0,
        //                             maxOccurs: 1,
        //                             nodeKind:
        //                                 'http://www.w3.org/ns/shacl#Literal',
        //                         },
        //                         {
        //                             id: 600,
        //                             propertyUri: 'http://p4',
        //                             definition: 'Dun Id',
        //                             label: 'Duns Identifier',
        //                             value: '56-9033332',
        //                             colspan: 1,
        //                             propertyName: 'dunsId',
        //                             minOccurs: 0,
        //                             maxOccurs: 1,
        //                             nodeKind:
        //                                 'http://www.w3.org/ns/shacl#Literal',
        //                         },
        //                         {
        //                             id: 700,
        //                             propertyUri: 'http://p4',
        //                             definition: 'CIK Number',
        //                             label: 'CIK Number',
        //                             value: '4567893',
        //                             colspan: 1,
        //                             propertyName: 'cikNumber',
        //                             minOccurs: 0,
        //                             maxOccurs: 1,
        //                             nodeKind:
        //                                 'http://www.w3.org/ns/shacl#Literal',
        //                         },
        //                     ],
        //                 },
        //             ],
        //         },
        //     },
        //     {
        //         value: 1,
        //         label: 'Test2',
        //         definition: 'Customer Addresses',
        //         viewport: {
        //             gridcols: 2,
        //             viewGroups: [],
        //         },
        //     },
        //     {
        //         value: 2,
        //         label: 'Test3',
        //         definition: 'Master/Clustered Records',
        //         viewport: {
        //             gridcols: 2,
        //             viewGroups: [],
        //         },
        //     },
        //     {
        //         value: 3,
        //         label: 'Test4',
        //         definition: 'Source Data Lineage.',
        //         viewport: {
        //             gridcols: 2,
        //             viewGroups: [],
        //         },
        //     },
        // ],
    };

    protected showDataElement($event: MouseEvent, item: FormField) {
        console.log(item);
        if (this.selectedDataElement()?.id === item.id) {
            console.log('hiding');
            this.op.hide();
            this.selectedDataElement.set(null);
        } else {
            console.log('setting', item);
            this.selectedDataElement.set(item);
            this.op.show(event);

            if (this.op.container) {
                this.op.align();
            }
        }
    }

    protected copyDataRecordSubject(value:string) {
        this.clipboard.copy(this.dataRecordView.subjectUri);
    }
}

